import DatabaseService from 'services/DatabaseService.js';
import {getActivity}  from 'reducers/activities.js';
import { ADD_ACTIVITY } from './types/index';

export const addActivity = (activity) => {
    return { type:ADD_ACTIVITY, activity:activity };
}


//Thunks

export const toggleReaction = (id) => (dispatch, getState) => {
    let state = getState();
    let activity = getActivity(state.activities, id);
    if (activity.feedActionReaction=== null){
        dispatch(addActivity({...activity, reactionCount:activity.reactionCount + 1, feedActionReaction:{}}));
    }else{
        dispatch(addActivity({...activity,reactionCount:activity.reactionCount -1, feedActionReaction:null}));
    }
}

export const addReport = (activityId,reportId,comment) => (dispatch, getState) =>{
    let state = getState();
    let activity = getActivity(state.activities,activityId)
    console.log('activity',activity)
    console.log('comment',comment)
    dispatch(addActivity({...activity,feedActionReport:{id:reportId,comment:comment}}))
}




// WEBPACK FOOTER //
// ./src/actions/activities.js